import React from "react";
import { Link } from "react-router-dom";
import { MapPin, BadgeCheck } from "lucide-react";
import { StarRating } from "@/components/StarRating";
import { priceRange } from "@/lib/format";
import { worldOf } from "@/lib/worlds";

export function ListingCard({ listing }) {
  const world = worldOf(listing.module);
  const img = listing.image_url || (listing.images && listing.images[0]);
  return (
    <Link
      to={`/listing/${listing.id}`}
      data-testid={`listing-card-${listing.id}`}
      className="group block overflow-hidden rounded-2xl bg-card border border-border card-hover"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-muted">
        {img && (
          <img
            src={img}
            alt={listing.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        )}
        <span
          className="absolute left-3 top-3 rounded-full px-2.5 py-1 text-[11px] font-semibold capitalize"
          style={{ background: world.accentSoft, color: world.accent }}
        >
          {world.name}
        </span>
        <span className="absolute bottom-3 left-3 rounded-full glass px-3 py-1 text-sm font-mono-num font-bold text-foreground shadow-sm">
          {priceRange(listing)}
          <span className="text-[10px] font-sans font-medium text-muted-foreground"> /{listing.price_unit}</span>
        </span>
      </div>
      <div className="p-3.5">
        <div className="flex items-center gap-1">
          <h3 className="truncate font-semibold text-[15px] leading-tight">{listing.title}</h3>
          {listing.verified && <BadgeCheck size={15} style={{ color: "var(--fable)" }} className="shrink-0" />}
        </div>
        {listing.subtitle && <p className="mt-0.5 truncate text-xs text-muted-foreground">{listing.subtitle}</p>}
        <div className="mt-2.5 flex items-center justify-between">
          <StarRating rating={listing.rating} count={listing.review_count} />
          {listing.location && (
            <span className="inline-flex max-w-[55%] items-center gap-0.5 truncate text-xs text-muted-foreground">
              <MapPin size={12} className="shrink-0" />
              <span className="truncate">{listing.location}</span>
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}
